<template>
  <div class="Instruction" style="background-color: #fafafa;padding: 20px">
    <el-breadcrumb separator="/" style="margin-left: 10px; margin-top: 5px">
      <el-breadcrumb-item :to="{ path: '/console' }" >数据中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/Instruction' }" >特发指令管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="font-size: 25px;margin-top: 15px" >
      <p>资金特发管理</p>
    </div>
    <div style="margin-top: 20px;margin-bottom: 20px">
      <el-row>
        <el-col :span="5">
          <div style="width: 250px">
            <div style="float: left">
              <el-button style="color: white;border-color: #FF6633; background-color: #FF6633"  type="info" @click="templates">下载模板</el-button>
            </div>
            <div style="float: left;margin-left: 20px">
              <el-upload action="" :auto-upload="false" :on-change="onChange" :limit="50" :show-file-list="false" :disabled="dashboardSales">
                <el-button style="color: white;border-color: #FF6633; background-color: #FF6633" type="info" :loading="loading" :disabled="dashboardSales">上传文件</el-button>
              </el-upload>
            </div>
          </div>
        </el-col>
        <el-col :span="5" class="text" style="text-align: left" v-if="msg != ''">
          <div v-html="msg"></div>
        </el-col>
        <el-col :span="msg == '' ? 19:14" class="text">
          <div>提示：指令上传后无法再修改，请确认上传数据正确。金额允许的范围：0.01元-20000元</div><br>
          <div>每日21:00-22:00系统结算一次特发，平台收取15元/人/月的服务费用</div>
        </el-col>
      </el-row>
<!--      <el-form label-width="20px" style=" margin-top: 20px; text-align: left ;" >-->
<!--        <el-form-item style="margin-bottom: 10px">-->
<!--          <div class="grid-content bg-purple" style="float:left;width: 10vw">-->
<!--              <el-upload action="" :auto-upload="false" :on-change="onChange" :limit="50" :show-file-list="false" >-->
<!--                <el-button style="background-color: #EF6C00" type="info">上传文件</el-button>-->
<!--              </el-upload>-->
<!--            </div>-->
<!--            <div class="grid-content bg-purple-light">-->
<!--              <el-button style="background-color: #EF6C00"  type="info" @click="templates">下载模板</el-button>-->
<!--            </div>-->
<!--        </el-form-item>-->
<!--        <el-form-item style="margin-bottom: 0px">-->
<!--          <p>提示：指令上传后无法再修改，请确认上传数据正确</p>-->
<!--        </el-form-item>-->
<!--        <el-form-item style="margin-bottom: 0px">-->
<!--          <p>金额允许的范围：0.01元-9999.99元</p>-->
<!--        </el-form-item>-->
<!--        <el-form-item style="margin-bottom: 10px">-->
<!--          <p>每日<span style="color: red">21:00-22:00</span>系统结算一次特发，平台收取15元/人/月的服务费用</p>-->
<!--        </el-form-item>-->
<!--      </el-form>-->
    </div>
    <div>
      <el-table
      :data="tableData"
      height="450"
      border
      style="width: 100%">
      <el-table-column
        prop="saleId"
        label="导购ID"
        align="center"
        width="120">
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        align="center"
        width="90">
      </el-table-column>
      <el-table-column
        prop="province"
        label="省份"
        align="center"
        width="90">
      </el-table-column>
        <el-table-column
          prop="city"
          label="城市"
          align="center"
          width="90">
        </el-table-column>
        <el-table-column
          prop="district"
          label="区县"
          align="center"
          width="90">
        </el-table-column>
        <el-table-column
          prop="brand"
          label="连锁品牌"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          prop="storeName"
          label="门店名称"
          align="center"
          width="150">
        </el-table-column>
        <el-table-column
          prop="bonus"
          label="金额"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="description"
          label="备注"
          align="center">
        </el-table-column>
        <el-table-column
          prop="createdat"
          label="指令时间"
          align="center"
          width="100">
        </el-table-column>
        <el-table-column
          prop="status"
          align="center"
          width="100"
          label="发放时间">
        </el-table-column>
    </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        layout="prev, pager, next"
        :total='total' style="text-align: center">
      </el-pagination>
    </div>
      <el-dialog
              :visible.sync="toTrainingButton"
              width="700px"
              class="trainingDialog"
              :show-close="false"
              :close-on-click-modal="false"
              center>
          <div slot="title" class="dialog-title" style="position: relative; display: flex; justify-content: center; align-items: center;">
              <div style="flex: 1; text-align: center;">资金特发管理功能已升级，点击前往体验新版功能</div>
              <i @click="closeToTrainingDialog" style="cursor: pointer; position: absolute; right: 0;top:-10px" class="el-dialog__close el-icon el-icon-close"></i>
          </div>
          <div class="content">
              <el-button class="orangev-btn" size="medium" type="info" :loading="loading2" @click="toTraining">
                  通路活动-渠道激励
              </el-button>

              <div class="bold height-50 font-17" style="margin-top: 20px">启用通路活动的好处：</div>

              <div class="description font-17">
                  <div>1.通过公众号消息、小程序流程中心通知被奖励人，展示具体活动政策、增强被奖励人的感知，提升奖励效果和渠道忠诚度。
                  </div>
                  <div>2.奖励可依据活动政策分类，能独立导出报表，易于统计各类奖励金额和效果。</div>
              </div>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import { template, RecordSelect, RecordCounts, RecordAdd } from '@/api/Instruction'
import XLSX from 'xlsx'
import AES from "@/api/AES";
import router from "@/router";
import {saveTrainingUser} from "@/api/login";

export default {
  data () {
    return {
      tableData: [],
      token: '',
      fileList: [],
      localFile: {},
      data: '',
      uploadings: 0,
      total: 0,
      pageNO: 0,
      pageSize: 50,
      instruction: [],
      loading: false,
      loading2: false,
      msg: '',
      dashboardSales:false
    }
  },
  computed : {
      toTrainingButton() {
          return this.$store.state.toTrainingDialog
      }
  },
  created () {
    this.$store.commit('addTips',['模板表格说明：',
      '导购ID：表现为一串6位数字，是每位导购唯一的身份识别号，可在导购员名单中的ID列查找到。',
      '一致性检验：表格上传时，系统会自动检测导购姓名与导购ID的一致性，验证成功后，相应特发资金将发送到该导购红利账户'
    ]);
    this.$store.commit('toTrainingButton',true)
    this.$store.commit('openToTrainingDialog',true)

    setTimeout(function(){
      var element = document.getElementsByClassName('el-header')[2]
      element.getElementsByTagName('div')[2].innerHTML = '<div><div style="font-weight: 600">模板表格说明：</div><br></div>';
      element.getElementsByTagName('div')[5].innerHTML = '<div><div><span style="font-weight: 600">导购ID：</span>表现为一串6位数字，是每位导购唯一的身份识别号，可在<a id="a1" style="cursor: pointer">导购员名单</a>中的ID列查找到。</div><br></div>';
      element.getElementsByTagName('div')[8].innerHTML = '<div><div><span style="font-weight: 600">一致性检验：</span>表格上传时，系统会自动检测导购姓名与导购ID的一致性，验证成功后，相应特发资金将发送到该导购红利账户</div><br></div>';
      document.getElementById("a1").onclick = function (){
        router.push({ path: '/ReportDetailPagePurchase' })
      }
    },0);
    // 每一次进入这个页面就提取一次权限
    this.searchs = AES.decrypt(localStorage.getItem('qx'))
    let bonus_order = localStorage.getItem('bonus_order')
    this.dashboardSales = localStorage.getItem('dashboardSales') == 2 ? true : false
    if ((this.searchs === '4' || this.searchs === '1') && bonus_order == 1) {
      this.RecordSelects()
      this.RecordCounts()
    }else {
      this.$router.replace({ path: '/console' })
    }
  },
  methods: {
    templates () {
      template(this.token).then(res => {
        if (res !== null) {
          this.handleDownload(res)
        }
      })
    },
    handleDownload (res) {
      // 创建下载的链接
      // 设置该文件的mime类型，这里对应的mime类型对应为.xlsx格式
      let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      const fileName = decodeURI(res.headers['filename'])
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
    },
    uploading () {
      // 校验值是否正确
      var i = 0
      if (this.data.length !== 0) {
        try {
          // 校验手机号 首先不能为空 其次是手机号的正确性 如果不正确 退出整个循环
          this.data.forEach(up => {
            if (!up.导购ID) {
              this.$notify.error({
                message: '第' + [i + 2] + '行的导购ID为空'
              })
              throw new Error('EndIterative')
            } else {
              console.log("执行")
              console.log(up.导购ID)
              if (up.导购ID.toString().length < 6) {
                this.$notify.error({
                  message: '第' + [i + 2] + '行的导购ID格式错误'
                })
                throw new Error('EndIterative')
              }
            } if (!up.导购姓名) {
              this.$notify.error({
                message: '第' + [i + 2] + '行的导购姓名为空'
              })
              throw new Error('EndIterative')
            } if (!up.金额) {
              // 判断金额是否填写
              this.$notify.error({
                message: '第' + [i + 2] + '行的金额为空'
              })
              throw new Error('EndIterative')
            } else {
              // 给金额转换成数字  在判断金额填写等待钱是否正确
              this.uploadings = parseFloat(up.金额)
              if (!(this.uploadings > 0)) {
                this.$notify.error({
                  message: '第' + [i + 2] + '行的金额小于0'
                })
                throw new Error('EndIterative')
              } else if (this.uploadings > 20000) {
                this.$notify.error({
                  message: '第' + [i + 2] + '行的金额大于20000'
                })
                throw new Error('EndIterative')
              }
            } if (!up.备注) {
              this.$notify.error({
                message: '第' + [i + 2] + '行的备注为空'
              })
              throw new Error('EndIterative')
            } else {
              if (up.备注.length > 50) {
                this.$notify.error({
                  message: '第' + [i + 2] + '行的备注的字符长度过长'
                })
                throw new Error('EndIterative')
              }
            }
            // this.instruction = up
            // console.log(this.instruction)
            this.instruction.push({ password: up.导购ID, name: up.导购姓名, description: up.备注, bonus: up.金额 })
            i++
          })
          RecordAdd(this.token, this.instruction).then(res => {
            if (res.status === 200) {
              const {data} = res
              console.log(data)
              this.msg = data.date
              if (data.code === 1) {
                this.$notify({
                  type: 'error',
                  message: data.msg,
                  title: '失败'
                })
              } else {
                this.$notify({
                  type: 'success',
                  message: '上传成功',
                  title: '成功'
                })
              }
              this.RecordSelects()
              this.RecordCounts()
            }
          })
        } catch (error) {
          let status = error.response.status;
          if (status == 500){
            if (error.message !== 'EndIterative') throw error
          }
        }finally {
          this.loading = false
        }
      } else {
        alert('execl为空')
        this.loading = false
      }
    },
    async onChange (file) {
      // 解析导入的excel 表格 获取值
      this.loading = true
      this.instruction = []
      let dataBinary = await readFile(file, this)
      let workBook = XLSX.read(dataBinary, { type: 'binary', cellDates: true })
      let workSheet = workBook.Sheets[workBook.SheetNames[0]]
      this.data = XLSX.utils.sheet_to_json(workSheet)
      this.uploading()
    },
    RecordSelects () {
      // 进入页面以后 进行查询 给表格赋值
      this.token = localStorage.getItem('token')
      RecordSelect(this.token, this.pageNO, this.pageSize).then(res => {
        if (res.status === 200) {
          this.tableData = res.data
        }
      })
    },
    RecordCounts () {
      // 查询条数给分页
      RecordCounts(this.token).then(res => {
        this.total = res.data % 50 === 0 ? (res.data / 50) + 1 : (res.data / 50)
        this.total = this.total * 10
      })
    },
    handleCurrentChange (val) {
      // 分页点击以后进入方法 然后回响给后台  进行分页查找
      this.pageNO = val - 1
      this.RecordSelects()
    },
    closeToTrainingDialog() {
        this.$store.commit('openToTrainingDialog',false)
    },
    //点击跳转
    toTraining() {
        this.loading2 = true
        saveTrainingUser(this.token,{from: 'ov:/Instruction',to:'training:/Training/Activity/ActivityTF'}).then(res => {
            let {code,date,msg} = res.data
            if (code === 200) {
                // 构造目标URL，确保正确处理末尾的斜杠
                let targetUrl = 'https://shop.orangev.cn:1234/course/#/';
                if (!targetUrl.endsWith('?')) {
                    targetUrl += '?';
                }
                // 拼接参数
                targetUrl += `&userKey=${encodeURIComponent(date)}`;
                // 执行页面跳转
                window.open(targetUrl)
            } else {
                this.$notify.error({
                    title: '错误',
                    message: msg,
                    position: 'bottom-right'
                })
            }
        }).finally(() => {
            this.loading2 = false
            this.$store.commit('openToTrainingDialog',false)
        })
    }
  }
}
/* 读取文件 */
export const readFile = (file) => {
  // 解析导入的excel 表格 获取值
  return new Promise(resolve => {
    let reader = new FileReader()
    reader.readAsBinaryString(file.raw)
    reader.onload = ev => {
      resolve(ev.target.result)
    }
  })
}
</script>

<style scoped>
.text {
  line-height: 1.35em;
  text-align: right;
  font-size: 10px;
  padding:0;
  font-family: 微软雅黑;
  font-weight: 0;
  color: #909399
}

.trainingDialog .dialog-title {
    margin-top: 10px;
    color: black;
    font-size: 20px;
}

.trainingDialog .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 25px;
}

.trainingDialog .description {
    color: #666666;
    letter-spacing: 1px;
    line-height: 25px;
}

.trainingDialog .orangev-btn {
    color: white;
    border-color: #FF6633;
    background-color: #FF6633;
    padding: 15px 20px;
    font-size: 17px;
}

.trainingDialog .bold {
    font-weight: bold;
}

.trainingDialog .height-50 {
    line-height: 50px;
    height: 50px;
}

.trainingDialog .font-17 {
    font-size: 17px;
}
</style>
